module.exports = __webpack_public_path__ + "static/media/save_forms_icon.e7d67bd3.svg";